<template>
  <div
    class="collapse navbar-collapse w-auto h-auto h-100"
    id="sidenav-collapse-main"
  >
    <ul class="navbar-nav">
      <li class="nav-item" v-if="isAdminOrSupervisor || isFieldWorker">
        <sidenav-item
          url="/dashboard-default"
          :class="getRoute() === 'dashboard-default' ? 'active' : ''"
          :navText="metricsNavText"
        >
          <template v-slot:icon>
            <i class="fas fa-home text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="isAdminOrSupervisor">
        <sidenav-item
          url="/pos"
          :class="getRoute() === 'pos' ? 'active' : ''"
          navText="POS"
        >
          <template v-slot:icon>
            <i class="fas fa-cash-register text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="isAdminOrSupervisor">
        <sidenav-item
          url="/users"
          :class="getRoute() === 'users' ? 'active' : ''"
          navText="Usuarios"
        >
          <template v-slot:icon>
            <i class="fas fa-users text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="isOperario">
        <sidenav-item
          url="/production-user"
          :class="getRoute() === 'production-user' ? 'active' : ''"
          navText="Producción"
        >
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="isAdminOrSupervisor">
        <sidenav-item
          url="/supplies"
          :class="getRoute() === 'supplies' ? 'active' : ''"
          navText="Inventario"
        >
          <template v-slot:icon>
            <i class="fas fa-box text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="isAdminOrSupervisor">
        <sidenav-item
          url="/purchases"
          :class="getRoute() === 'purchases' ? 'active' : ''"
          navText="Compras / Salidas"
        >
          <template v-slot:icon>
            <i class="fas fa-shopping-cart text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="isAdminOrSupervisor">
        <sidenav-item url="/remissions" :class="getRoute() === 'remissions' ? 'active' : ''" navText="Ventas / Entradas">
          <template v-slot:icon>
            <i class="fas fa-file-alt text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="(isAdminOrSupervisor || isFieldWorker) && serviceOrdersEnabled">
        <sidenav-item
          url="/service-orders"
          :class="getRoute() === 'service-orders' ? 'active' : ''"
          navText="Orden de Servicio"
        >
          <template v-slot:icon>
            <i class="fas fa-motorcycle text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="isAdminOrSupervisor || isFieldWorker">
        <sidenav-item
          url="/worker-tasks"
          :class="isWorkerTasksRoute ? 'active' : ''"
          navText="Trabajos"
        >
          <template v-slot:icon>
            <i class="fas fa-tools text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="isAdminOrSupervisor">
        <sidenav-item
          url="/cash-closures"
          :class="getRoute() === 'cash-closures' ? 'active' : ''"
          navText="Cierres de Caja"
        >
          <template v-slot:icon>
            <i class="fas fa-cash-register text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>

      <li class="nav-item" v-if="isAdmin">
        <sidenav-item
          url="/settings"
          :class="getRoute() === 'settings' ? 'active' : ''"
          navText="Configuración"
        >
          <template v-slot:icon>
            <i class="ni ni-settings-gear-65 text-warning text-sm opacity-10"></i>
          </template>
        </sidenav-item>
      </li>
     
    </ul>
  </div>
  <div class="mx-3 sidenav-footer text-center mt-3">
   

  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import SidenavItem from "./SidenavItem.vue";


export default {
  name: "SidenavList",
  props: {
    cardBg: String,
  },
  data() {
    return {
      title: "Argon Dashboard 2",
      controls: "dashboardsExamples",
      isActive: "active",
      dropDownStatus: true,
    };
  },
  components: {
    SidenavItem,
  },
  computed: {
    ...mapGetters('settings', ['serviceOrdersEnabled']),
    user() {
      try {
        const stored = localStorage.getItem('user');
        if (!stored) {
          return {};
        }
        const parsed = JSON.parse(stored);
        return {
          ...parsed,
          role: String(parsed?.role ?? ''),
        };
      } catch {
        return {};
      }
    },
    userRole() {
      const role = this.user?.role;
      return String(role ?? '').trim();
    },
    isAdmin() {
      return this.userRole === '1';
    },
    isAdminOrSupervisor() {
      return this.userRole === '1' || this.userRole === '2';
    },
    isOperario() {
      return this.userRole === '3';
    },
    isOperador() {
      return this.userRole === '6';
    },
    isFieldWorker() {
      return this.isOperario || this.isOperador;
    },
    metricsNavText() {
      return this.isFieldWorker ? 'Métricas del operario' : 'Métricas';
    },
    isWorkerTasksRoute() {
      const segment = this.getRoute();
      return segment === 'worker-tasks';
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('settings/get');
    } catch (error) {
      console.error('Error loading settings for menu:', error);
    }
  },
  methods: {
    getRoute() {
      const routeArr = this.$route.path.split("/");
      return routeArr[1];
    },
    useDropDown() {
      this.dropDownStatus = !this.dropDownStatus;
    },
   
  },
};
</script>
